module.exports = __webpack_public_path__ + "img/InicioSinFotos.648456d1.png";